export default "__VITE_ASSET__9$Po2w8E__"